import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminOtpComponent } from './admin-otp.component';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: AdminOtpComponent
  }
];
import {
  NbCardModule,
  NbButtonModule,
  NbInputModule
} from '@nebular/theme';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
@NgModule({
  declarations: [AdminOtpComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    NbCardModule,
    NbButtonModule,
    NbInputModule,
    MatProgressSpinnerModule
  ],
  exports: [
    AdminOtpComponent
  ]
})
export class AdminOtpModule {



 }
